import React from 'react';
import { Helmet } from 'react-helmet-async';

const Seo = ({ title, description, keywords, image, url, type = 'website' }) => {
  // 1. KRİTİK DÜZELTME: Artık gerçek domaini yazıyoruz
  const siteUrl = "https://mertt.tr";
  
  // Ayarlar
  const siteTitle = "MERTT";
  const fullTitle = title ? `${title} | ${siteTitle}` : "MERTT - Gelecek İçin Bilgi ve Teknoloji";
  
  // Varsayılan Açıklamayı biraz daha SEO uyumlu, kelime dolu yaptık
  const defaultDescription = "Gelecek İçin Bilgi Ve Teknoloji. Endüstri 4.0, Yapay Zeka, Web Yazılım ve Mühendislik çözümleri sunan teknoloji platformu.";
  
  const metaDescription = description || defaultDescription;
  const metaImage = image || `${siteUrl}/MERTT.png`;
  const metaUrl = url || siteUrl;

  // Google için Yapısal Veri (Schema.org)
  // Bu kod sayesinde Google seni "Rastgele Site" değil "Teknoloji Organizasyonu" olarak görür.
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": type === 'article' ? "Article" : "Organization",
    "name": siteTitle,
    "url": siteUrl,
    "logo": `${siteUrl}/MERTT.png`,
    "description": defaultDescription,
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+90-500-000-0000", // Burayı ilerde gerçek numaranla güncellersin
      "contactType": "customer service"
    }
  };

  return (
    <Helmet>
      {/* --- TEMEL ETİKETLER --- */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={keywords || "mertt, MERTT, MERTTA.Ş, MERTT A.Ş, YAZILIMIN GELECEĞİ, ARGE, TASARIM, endüstri 4.0, yapay zeka, bursa yazılım, teknoloji , seo , agent , aı agent"} />
      
      {/* CANONICAL URL (Çok Önemli): Google'a 'Benim tek adresim budur' der */}
      <link rel="canonical" href={metaUrl} />

      {/* --- SOSYAL MEDYA (Open Graph) --- */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:site_name" content={siteTitle} />

      {/* --- TWITTER --- */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />

      {/* --- GOOGLE KİMLİK KARTI (SCHEMA) --- */}
      <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </Helmet>
  );
};

export default Seo;